<script setup lang="ts">
import type { MathTaskAssignment } from "~/types/article"

const { showSuggestions, showAssignmentInSuggestion = true } = defineProps<{
  assignment: MathTaskAssignment
  showSuggestions?: boolean
  showAssignmentInSuggestion?: boolean
}>()

const { data: suggestedSolutionsData } = useMathTaskSolutions()
</script>

<template>
  <div class="text-[18px] md:text-[24px] [&>*]:font-national2">
    <URichText
      v-show="!showSuggestions || showAssignmentInSuggestion"
      :html="assignment.text"
    />
    <div
      :class="`${
        showSuggestions
          ? 'mt-3 rounded bg-green-lightest p-4 md:px-8 md:py-6 lg:rounded-lg'
          : ''
      }`"
    >
      <USuggestedSolutionSection
        v-if="showSuggestions"
        :sections="suggestedSolutionsData?.suggestedSolutions.get(assignment.id)"
      />
    </div>
  </div>
</template>
